import { getQueryClient } from 'app/get-query-client';
import type { ServerError } from 'models';
import { referralsSummaryKeys } from 'queries/referralsSummary';
import { postSignupReferralCode } from 'transport/domains/signup';
import { fetchSardineSessionKey } from 'utils/sardine';

const REFERRAL_INFO_REFRESH_DELAY_MS = 1000;

function refreshReferralInfo(): void {
    void getQueryClient().invalidateQueries({ queryKey: referralsSummaryKeys.all });
}

export async function submitPostSignupReferralCode(
    email: string,
    referralCode: string,
    onSuc: () => void,
    onErr: (err: ServerError) => void,
): Promise<void> {
    const sardineSessionKey = await fetchSardineSessionKey('signup');
    postSignupReferralCode(
        {
            email,
            referral_code: referralCode,
            sardine_session_key: sardineSessionKey || undefined,
        },
        () => {
            setTimeout(refreshReferralInfo, REFERRAL_INFO_REFRESH_DELAY_MS);
            onSuc();
        },
        onErr,
    );
}
